import { SearchModes } from '@/domainLogic/index.ts';
import { DESTINATION_TYPE } from '@/app/search/types.ts';
import type { TranslationFunction } from '@/app/components/translations/Translation.tsx';
import getSearchParams from '@/app/components/search/common/getSearchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import { SortValues } from '@/app/common/memsearch/types.ts';

type SortOption = {
  label: string;
  value: SortValues;
  isSelected: boolean;
};

type CreateSortOptionsProps = {
  searchMode: SearchModes;
  destinationType?: DESTINATION_TYPE;
  t: TranslationFunction;
};
export const createSortOptions = ({ searchMode, destinationType, t }: CreateSortOptionsProps): SortOption[] => {
  const distanceCity =
    destinationType === DESTINATION_TYPE.CITY
      ? [
          {
            value: SortValues.DistanceCity,
            label: t('vacation.oss.components.searchresults.sort.distance_city'),
            isSelected: false,
          },
        ]
      : [];
  const distanceAirport =
    searchMode === SearchModes.DP
      ? [
          {
            value: SortValues.DistanceAirport,
            label: t('vacation.oss.components.searchresults.sort.distance_airport'),
            isSelected: false,
          },
        ]
      : [];

  const options = [
    {
      label: t('vacation.oss.components.searchresults.sort.recommended'),
      value: SortValues.Recommended,
      isSelected: false,
    },
    {
      value: SortValues.PriceAsc,
      label: t('vacation.oss.components.searchresults.sort.price_asc'),
      isSelected: false,
    },
    {
      value: SortValues.PriceDesc,
      label: t('vacation.oss.components.searchresults.sort.price_desc'),
      isSelected: false,
    },
    {
      value: SortValues.CategoryDesc,
      label: t('vacation.oss.components.searchresults.sort.category_desc'),
      isSelected: false,
    },
    {
      value: SortValues.CategoryAsc,
      label: t('vacation.oss.components.searchresults.sort.category_asc'),
      isSelected: false,
    },
    {
      value: SortValues.TopReviewed,
      label: t('vacation.oss.components.searchresults.sort.top_reviewed'),
      isSelected: false,
    },
    ...distanceCity,
    ...distanceAirport,
  ];

  const searchParamsFresh = getSearchParams();
  const sortUrlValue = searchParamsFresh[URLParameters.SORT] || SortValues.Recommended;
  const selectedValue =
    Object.values(SortValues).includes(sortUrlValue as SortValues) &&
    options.find((option) => option.value === sortUrlValue)
      ? sortUrlValue
      : SortValues.Recommended;

  return options.map((option) => ({
    ...option,
    isSelected: option.value === selectedValue,
  }));
};
